export default __webpack_public_path__ + "static/media/Royal Neighbors of America Dark.b67b2736.svg";